import { RouteConfig } from "vue-router";

const notificaciones: RouteConfig = {
  path: "/notificaciones",
  name: "notificaciones",
  component: () => import(/* webpackChunkName: "notificaciones" */ "@/views/Notificaciones.vue"),
};

export default notificaciones;
